module.exports = __webpack_public_path__ + "img/Logo.0a322b48.svg";